import { render, staticRenderFns } from "./VerifyEmailSignup-fr.vue?vue&type=template&id=bc77e242&"
import script from "./VerifyEmailSignup-fr.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailSignup-fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports